import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ConfigContext } from "../context/GlobalContext";
import { getImage } from "../Utils/image_helper";
import { Languages } from "../Utils/Languages";

const PremiumCard = () => {
    const { state } = useContext(ConfigContext);
    const navigate = useNavigate();

    // If the user is logged in but premium status is still being fetched (null), show nothing
    if (state?.USERID && state?.PREMIUM === null) return null;

    const isPremium = state?.USERID && state?.PREMIUM;

    return (
        <div className="mt-3 p-0">
            {isPremium ? (
                <button
                    className="container mt-3 p-0"
                    onClick={() => navigate("/payment")}
                >
                    <div
                        className="alert p-3 rounded bg-light border border-success shadow-sm"
                        style={{
                            background: `url(${getImage("premium")})`,
                            backgroundSize: "cover",
                        }}
                    >
                        <div className="d-flex align-items-center ">
                            <svg
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                className="text-white"
                                width="22"
                                height="22"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                />
                            </svg>

                            <p className="fw-semibold mb-0 ms-2 text-white" style={{ fontSize: 16 }}>
                                {Languages[state?.LANGUAGE]?.premium_access}
                            </p>
                        </div>

                        <div className="mt-2">
                            <span className="text-white" style={{ fontSize: 14, marginLeft: 28 }}>
                                {Languages[state?.LANGUAGE]?.valid_until}
                            </span>

                            <div
                                className="mt-1 p-2 text-white fw-bold rounded text-center"
                                style={{ background: "#4226c3" }}
                            >
                                {state?.PREMIUMLASTDATE || "N/A"}
                            </div>
                        </div>
                    </div>
                </button>
            ) : (
                <button
                    className="btn fw-bold border-0 px-4 py-3 position-relative"
                    style={{
                        borderRadius: "12px",
                        background: `url(${getImage("gradient")})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                        width: "100%",
                        maxWidth: "280px",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        padding: "12px 20px",
                    }}
                    onClick={() => navigate("/pricing")}
                >
                    <i
                        className="fas fa-crown"
                        style={{ fontSize: "18px", color: "gold" }}
                    ></i>
                    <span style={{ fontSize: "16px", fontWeight: "600" }}>
                        Upgrade to Premium
                    </span>
                </button>
            )}
        </div>
    );
};

export default PremiumCard;

